export const NEWS_SECTION_CONTENT = {
    sectionTitle: 'Tin tức mới nhất',
    sectionSubText: 'Cập nhật thông tin từ Studio',
};
